import { forwardRef } from "react";

type ImageProps = {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  fill?: boolean;
  className?: string;
  style?: React.CSSProperties;
  loading?: "lazy" | "eager";
  onLoad?: React.ReactEventHandler<HTMLImageElement>;
  onError?: React.ReactEventHandler<HTMLImageElement>;
  onClick?: React.MouseEventHandler<HTMLImageElement>;
  // next/image-only props that we accept and ignore
  unoptimized?: boolean;
  sizes?: string;
  priority?: boolean;
  quality?: number;
  loader?: unknown;
  placeholder?: string;
  blurDataURL?: string;
};

// SPA shim for next/image. Renders a plain <img>; sizing handled via CSS.
// next/image-only props (unoptimized, sizes, priority, etc.) are accepted and
// ignored so a mass copy of legacy code compiles unchanged.
export const Image = forwardRef<HTMLImageElement, ImageProps>(function Image(
  { src, alt = "", width, height, fill, className, style, loading = "lazy", onLoad, onError, onClick },
  ref,
) {
  if (fill) {
    return (
      <img
        ref={ref}
        src={src}
        alt={alt}
        loading={loading}
        className={`absolute inset-0 h-full w-full object-cover ${className ?? ""}`}
        style={style}
        onLoad={onLoad}
        onError={onError}
        onClick={onClick}
      />
    );
  }
  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      className={className}
      style={style}
      onLoad={onLoad}
      onError={onError}
      onClick={onClick}
    />
  );
});
